import script from "./SearchForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchForm.vue?vue&type=script&lang=ts&setup=true"

import "./SearchForm.vue?vue&type=style&index=0&id=65c03610&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65c03610"]])

export default __exports__